// src/initializeDataStoreConfig.ts
import { setAPIConfig } from '@o2x/data-store'
import { getApiUrl } from 'shared/utils/url'

/**
 * Initializes the data-store configuration.
 */
export function initializeDataStoreConfig() {
  const v1Url = getApiUrl({ version: 'v1' })
  const v2Url = getApiUrl({ version: 'v2' })
  const v3Url = getApiUrl({ version: 'v3' })
  const v4Url = getApiUrl({ version: 'v4' })
  const ossUrl = getApiUrl({ version: 'oss' })
  const microUrl = getApiUrl({ version: 'fastapi' })

  // Merge default config with mobile-specific overrides
  const finalConfig = {
    urls: {
      api: v1Url ?? '',
      api2: v2Url ?? '',
      api3: v3Url ?? '',
      api4: v4Url ?? '',
      oss: ossUrl ?? '',
      // apiMicros: 'dev.api.o2x.com/',
      // apiMicros: 'http://localhost:8888/',
      apiMicros: microUrl ? `${microUrl}/` : '',
    },
    tokenKey: '',
  }
  // Set the final configuration for data-store
  setAPIConfig(finalConfig)
}
